// hydration.actions.ts
import { createAction, props } from '@ngrx/store'

export const hydrate = createAction('[Hydration] Hydrate')

export const hydrateSuccess = createAction('[Hydration] Hydrate Success', props<any>())

export const hydrateFailure = createAction('[Hydration] Hydrate Failure')

export const removeState = createAction('[Hydration] Remove state')
